import {
    Check, CircleNotch, Trash
} from '@phosphor-icons/react';
import clsx from 'clsx';

// 品牌图标 URL 映射表 - 参考设计稿实现
const BRAND_ICONS: Record<string, string> = {
    'Shopify': 'https://cdn.brandfetch.io/shopify.com/icon',
    'WooCommerce': 'https://cdn.brandfetch.io/woocommerce.com/icon',
    'BigCommerce': 'https://cdn.brandfetch.io/bigcommerce.com/icon',
    'Magento': 'https://cdn.brandfetch.io/magento.com/icon',
    'Wix': 'https://cdn.brandfetch.io/wix.com/icon',
    'Squarespace': 'https://cdn.brandfetch.io/squarespace.com/icon',
    'PrestaShop': 'https://cdn.brandfetch.io/prestashop.com/icon',
    'Salesforce Commerce': 'https://cdn.brandfetch.io/salesforce.com/icon',
    'Square': 'https://cdn.brandfetch.io/squareup.com/icon',
    'Toast': 'https://cdn.brandfetch.io/toasttab.com/icon',
    'Clover': 'https://cdn.brandfetch.io/clover.com/icon',
    'Lightspeed': 'https://cdn.brandfetch.io/lightspeedhq.com/icon',
    'Shopify POS': 'https://cdn.brandfetch.io/shopify.com/icon',
    'Vend': 'https://cdn.brandfetch.io/vendhq.com/icon',
    'Revel': 'https://cdn.brandfetch.io/revelsystems.com/icon',
    'TouchBistro': 'https://cdn.brandfetch.io/touchbistro.com/icon',
    'Meta Ads': 'https://cdn.brandfetch.io/facebook.com/icon',
    'Google Ads': 'https://cdn.brandfetch.io/ads.google.com/icon',
    'Facebook Ads': 'https://cdn.brandfetch.io/facebook.com/icon',
    'TikTok Ads': 'https://cdn.brandfetch.io/tiktok.com/icon',
    'Snapchat Ads': 'https://cdn.brandfetch.io/snapchat.com/icon',
    'Pinterest Ads': 'https://cdn.brandfetch.io/pinterest.com/icon',
    'LinkedIn Ads': 'https://cdn.brandfetch.io/linkedin.com/icon',
    'Twitter Ads': 'https://cdn.brandfetch.io/twitter.com/icon',
    'YouTube Ads': 'https://cdn.brandfetch.io/youtube.com/icon',
    'Klaviyo': 'https://cdn.brandfetch.io/klaviyo.com/icon',
    'Mailchimp': 'https://cdn.brandfetch.io/mailchimp.com/icon',
    'Attentive': 'https://cdn.brandfetch.io/attentive.com/icon',
    'Postscript': 'https://cdn.brandfetch.io/postscript.io/icon',
    'Omnisend': 'https://cdn.brandfetch.io/omnisend.com/icon',
    'Sendlane': 'https://cdn.brandfetch.io/sendlane.com/icon',
    'ActiveCampaign': 'https://cdn.brandfetch.io/activecampaign.com/icon',
    'Constant Contact': 'https://cdn.brandfetch.io/constantcontact.com/icon',
    'Google Analytics': 'https://cdn.brandfetch.io/analytics.google.com/icon',
    'Segment': 'https://cdn.brandfetch.io/segment.com/icon',
    'Mixpanel': 'https://cdn.brandfetch.io/mixpanel.com/icon',
    'Amplitude': 'https://cdn.brandfetch.io/amplitude.com/icon',
    'Heap': 'https://cdn.brandfetch.io/heap.io/icon',
    'Hotjar': 'https://cdn.brandfetch.io/hotjar.com/icon',
    'Looker': 'https://cdn.brandfetch.io/looker.com/icon',
    'Tableau': 'https://cdn.brandfetch.io/tableau.com/icon',
    'Stripe': 'https://cdn.brandfetch.io/stripe.com/icon',
    'PayPal': 'https://cdn.brandfetch.io/paypal.com/icon',
    'QuickBooks': 'https://cdn.brandfetch.io/quickbooks.intuit.com/icon',
    'Xero': 'https://cdn.brandfetch.io/xero.com/icon',
    'Square Payments': 'https://cdn.brandfetch.io/squareup.com/icon',
    'Braintree': 'https://cdn.brandfetch.io/braintreepayments.com/icon',
    'FreshBooks': 'https://cdn.brandfetch.io/freshbooks.com/icon',
    'Wave': 'https://cdn.brandfetch.io/waveapps.com/icon',
    'Zendesk': 'https://cdn.brandfetch.io/zendesk.com/icon',
    'Intercom': 'https://cdn.brandfetch.io/intercom.com/icon',
    'HubSpot': 'https://cdn.brandfetch.io/hubspot.com/icon',
    'Salesforce': 'https://cdn.brandfetch.io/salesforce.com/icon',
    'Gorgias': 'https://cdn.brandfetch.io/gorgias.com/icon',
    'Freshdesk': 'https://cdn.brandfetch.io/freshworks.com/icon',
    'Help Scout': 'https://cdn.brandfetch.io/helpscout.com/icon',
    'Pipedrive': 'https://cdn.brandfetch.io/pipedrive.com/icon',
    'ShipStation': 'https://cdn.brandfetch.io/shipstation.com/icon',
    'ShipBob': 'https://cdn.brandfetch.io/shipbob.com/icon',
    'Deliverr': 'https://cdn.brandfetch.io/deliverr.com/icon',
    'EasyShip': 'https://cdn.brandfetch.io/easyship.com/icon',
    'UPS': 'https://cdn.brandfetch.io/ups.com/icon',
    'FedEx': 'https://cdn.brandfetch.io/fedex.com/icon',
    'USPS': 'https://cdn.brandfetch.io/usps.com/icon',
    'DHL': 'https://cdn.brandfetch.io/dhl.com/icon',
    'Slack': 'https://cdn.brandfetch.io/slack.com/icon',
    'Discord': 'https://cdn.brandfetch.io/discord.com/icon',
    'Trello': 'https://cdn.brandfetch.io/trello.com/icon',
    'Asana': 'https://cdn.brandfetch.io/asana.com/icon',
    'Notion': 'https://cdn.brandfetch.io/notion.so/icon',
    'ClickUp': 'https://cdn.brandfetch.io/clickup.com/icon',
};

const getBrandIcon = (name: string) => {
    return BRAND_ICONS[name] || `https://cdn.brandfetch.io/${name.toLowerCase().replace(/\s+/g, '')}.com/icon`;
};

interface IntegrationCardProps {
    tool: string;
    supported: boolean;
    comingSoon?: boolean;
    isConnected: boolean;
    isSyncing: boolean;
    onConnect: () => void;
    onDisconnect?: () => void;
    canConnect?: boolean;
    canDisconnect?: boolean;
}

export default function IntegrationCard({
    tool,
    supported,
    isConnected,
    isSyncing,
    onConnect,
    onDisconnect,
    canConnect = true,
    canDisconnect = true,
}: IntegrationCardProps) {
    // comingSoon 优先级高于 supported
    const isAvailable = supported;
    const canClickConnect = canConnect && !isSyncing;
    const canClickDisconnect = canDisconnect && !isSyncing;

    return (
        <div
            className={clsx(
                "flex flex-col p-4 rounded-xl border transition-all duration-300 relative overflow-hidden h-full",
                isConnected
                    ? "border-gray-200 bg-white shadow-sm cursor-default group"
                    : isAvailable
                        ? "border-gray-200 bg-white shadow-sm hover:shadow-md hover:-translate-y-0.5 hover:border-gray-300 cursor-pointer group"
                        : "border-gray-200 bg-white shadow-sm cursor-default"
            )}
        >
            <div className="flex items-center gap-3">
                <div
                    className={clsx(
                        "w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-all duration-300",
                        "bg-white shadow-sm ring-1 ring-gray-100"
                    )}
                >
                    <img
                        src={getBrandIcon(tool)}
                        alt={tool}
                        className="w-5 h-5 object-contain"
                        onError={(e) => {
                            (e.target as HTMLImageElement).src = 'https://cdn.brandfetch.io/google.com/icon';
                        }}
                    />
                </div>
                <div className="min-w-0 flex-1">
                    <h4 className="font-semibold text-base leading-tight text-text-main text-gray-900 truncate" title={tool}>{tool}</h4>
                </div>
            </div>

            <div className="mt-auto pt-4">
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        if (isSyncing || !isAvailable) return;

                        if (isConnected && onDisconnect) {
                            if (!canClickDisconnect) return;
                            onDisconnect();
                        } else if (!isConnected) {
                            if (!canClickConnect) return;
                            onConnect();
                        }
                    }}
                    disabled={isSyncing || !isAvailable || (isConnected ? !canClickDisconnect : !canClickConnect)}
                    className={clsx(
                        "w-full px-3 py-2 rounded-lg text-sm font-semibold transition-all flex items-center justify-center shadow-sm",
                        isConnected
                            ? canClickDisconnect
                                ? "bg-green-100 border border-green-500 text-green-800 font-bold group-hover:bg-red-50 group-hover:border-red-500 group-hover:text-red-600"
                                : "bg-green-100 border border-green-500 text-green-800 font-bold cursor-not-allowed opacity-75"
                            : isAvailable
                                ? canClickConnect
                                    ? "bg-white border border-[#1A162F] text-[#1A162F] hover:bg-[#1A162F] hover:text-white"
                                    : "bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed"
                                : "bg-gray-100 text-text-sub text-gray-400 border border-gray-200 cursor-not-allowed"
                    )}
                >
                    {isSyncing ? (
                        <CircleNotch size={16} weight="bold" className="animate-spin" />
                    ) : isConnected ? (
                        <>
                            <div
                                className={clsx(
                                    "flex items-center gap-1.5",
                                    canClickDisconnect && "group-hover:hidden"
                                )}
                            >
                                <Check size={16} weight="bold" />
                                <span>Connected</span>
                            </div>
                            {canClickDisconnect ? (
                                <div className="hidden group-hover:flex items-center gap-1.5">
                                    <Trash size={16} weight="bold" />
                                    <span>Disconnect</span>
                                </div>
                            ) : null}
                        </>
                    ) : isAvailable ? (
                        "Connect"
                    ) : (
                        "Soon"
                    )}
                </button>
            </div>
        </div>
    );
}
